import { combineReducers } from 'redux';

import { agenciesFiltersReducer } from './filters';
import { agenciesListingReducer } from './listing';

export const agencies = combineReducers({
  listing: agenciesListingReducer,
  filters: agenciesFiltersReducer,
});
